import { createSlice } from '@reduxjs/toolkit';

const administrationSlice = createSlice({
  name: 'administration',
  initialState: {
    licenses: {
      list: [],
      totalRecords: 0,
    },
    devices: {
      inputClients: [],
      totalRecords: 0,
    },
  },
  reducers: {
    storeLicenses: (state, action) => {
      state.licenses = action.payload;
    },
    storeDevices: (state, action) => {
      state.devices = action.payload;
    },
    addOrUpdateDeviceStore: (state, action) => {
      const { data, actionType } = action.payload;
      if (actionType) {
        const devicesList = state.devices.inputClients.map((device) => {
          if (device.clientUuid === data.clientUuid) {
            return data;
          }
          return device;
        });
        state.devices.inputClients = devicesList;
      } else {
        state.devices.inputClients.unshift(data);
        state.devices.totalRecords += 1;
      }
    },
    removeDevice: (state, action) => {
      const devicesList = state.devices.inputClients.filter(
        (device) => device.clientUuid !== action.payload
      );
      state.devices.inputClients = devicesList;
      state.devices.totalRecords -= 1;
    },
  },
});

const {
  reducer: administrationReducer,
  actions: {
    storeLicenses,
    storeDevices,
    addOrUpdateDeviceStore,
    removeDevice,
  },
} = administrationSlice;

export {
  administrationReducer,
  storeLicenses,
  storeDevices,
  addOrUpdateDeviceStore,
  removeDevice,
};
